"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultPageDescriptor = exports.PageDescriptor = void 0;
const pageRedirect_1 = require("../redirects/pageRedirect");
/**
 * Entity that holds page and its properties
 */
class PageDescriptor {
    constructor(page, path, urlPath, scope, redirectBehavior = pageRedirect_1.noRedirectBehavior, isEditable = false, bannerWidget = null, privateCommunityAnonAllowed = false) {
        this.page = page;
        this.path = path;
        this.urlPath = urlPath;
        this.isEditable = isEditable;
        this.scope = scope;
        this.bannerWidget = bannerWidget;
        this.privateCommunityAnonAllowed = privateCommunityAnonAllowed;
        this.redirectBehavior = redirectBehavior;
    }
}
exports.PageDescriptor = PageDescriptor;
/**
 * Entity that holds default page descriptor and its properties
 */
class DefaultPageDescriptor {
    constructor(type, urlPath) {
        this.type = type;
        this.urlPath = urlPath;
    }
}
exports.DefaultPageDescriptor = DefaultPageDescriptor;
//# sourceMappingURL=index.js.map